import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML, encodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { magpHost } from "~/Utils";
import { useGuestLoginFooterPage } from "../../../Others.hook";
import { fields } from "../../../constants";

export const GuestLoginFooterPage = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const {
    data: editFaq,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditFaq,
  } = useGuestLoginFooterPage();

  const {
    data: FaqById,
    isLoading: isLoadingFaq,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    else{
      refetchEditFaq();
    }
  }, [query.get("id")]);

  const faqFormConfig: FormConfig = {
    initialValues: {
    button_text_en_0:FaqById ? decodeHTML(FaqById?.payload?.button_list?.[0]?.button_en) : decodeHTML(editFaq?.[0]?.button_list?.[0]?.button_en),
    button_text_en_1:FaqById ? decodeHTML(FaqById?.payload?.button_list?.[1]?.button_en) : decodeHTML(editFaq?.[0]?.button_list?.[1]?.button_en),
    button_text_en_2:FaqById ? decodeHTML(FaqById?.payload?.button_list?.[2]?.button_en) : decodeHTML(editFaq?.[0]?.button_list?.[2]?.button_en),
    button_text_ms_0:FaqById ? decodeHTML(FaqById?.payload?.button_list?.[0]?.button_ms) : decodeHTML(editFaq?.[0]?.button_list?.[0]?.button_ms),
    button_text_ms_1:FaqById ? decodeHTML(FaqById?.payload?.button_list?.[1]?.button_ms) : decodeHTML(editFaq?.[0]?.button_list?.[1]?.button_ms),
    button_text_ms_2:FaqById ? decodeHTML(FaqById?.payload?.button_list?.[2]?.button_ms) : decodeHTML(editFaq?.[0]?.button_list?.[2]?.button_ms),
    button_text_zh_0:FaqById ? decodeHTML(FaqById?.payload?.button_list?.[0]?.button_zh) : decodeHTML(editFaq?.[0]?.button_list?.[0]?.button_zh),
    button_text_zh_1:FaqById ? decodeHTML(FaqById?.payload?.button_list?.[1]?.button_zh) : decodeHTML(editFaq?.[0]?.button_list?.[1]?.button_zh),
    button_text_zh_2:FaqById ? decodeHTML(FaqById?.payload?.button_list?.[2]?.button_zh) : decodeHTML(editFaq?.[0]?.button_list?.[2]?.button_zh),
    button_link_0:FaqById ? decodeHTML(FaqById?.payload?.button_list?.[0]?.button_link) : decodeHTML(editFaq?.[0]?.button_list?.[0]?.button_link),
    button_link_1:FaqById ? decodeHTML(FaqById?.payload?.button_list?.[1]?.button_link) : decodeHTML(editFaq?.[0]?.button_list?.[1]?.button_link),
    button_link_2:FaqById ? decodeHTML(FaqById?.payload?.button_list?.[2]?.button_link) : decodeHTML(editFaq?.[0]?.button_list?.[2]?.button_link),
    copyright_text_en: FaqById
        ? decodeHTML(FaqById.payload.copyright_text_en?.value)
        : editFaq
          ? decodeHTML(editFaq?.[0]?.copyright_text_en)
          : "",
    copyright_text_ms: FaqById ? decodeHTML(FaqById.payload.copyright_text_ms?.Value) : editFaq ? decodeHTML(editFaq?.[0]?.copyright_text_ms) : "",
    copyright_text_zh: FaqById
        ? decodeHTML(FaqById.payload.copyright_text_zh?.value)
        : editFaq
          ? decodeHTML(editFaq?.[0]?.copyright_text_zh)
          : "",
    image: FaqById ? decodeHTML([
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: FaqById?.payload?.image,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: editFaq?.[0]?.image
            },
          ]),
    },
    fields: fields.guestLoginFooterPage,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let excludedKeys: any = [];
    // for (let key in data) {
    //   if (typeof data[key] === "string" && !excludedKeys.includes(key)) {
    //     data[key] = encodeHTML(data[key]);
    //   }
    // }
    let imageKeys: any = [
      "image",
    ];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "MAGP");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }
    let descKeys: any = [
        "description_zh",
        "description_ms",
        "description_en",
      ];
      for (const key of descKeys) {
        try {
          data[key] = {
            value: data[key] || "",
            format: "full_html",
          };
        } catch (error) {}
      }

    const payload = {
      action: action,
      method: method,
      module: "OTHERS",
      subModule: `banners_webFooterImages_guestLoginFooterPage`,
      type: "DEDICATED",
      application: "MAGP",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAGP",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        id: editFaq?.[0]?.id || FaqById?.payload?.id,
        title: editFaq?.[0]?.title || FaqById?.payload?.title,
        image: data?.image,
        button_list: [
            {
                id: 31,
                button_en: data?.button_text_en_0,
                button_ms: data?.button_text_ms_0,
                button_zh: data?.button_text_zh_0,
                button_link: data?.button_link_0
            },
            {
                id: 32,
                button_en: data?.button_text_en_1,
                button_ms: data?.button_text_ms_1,
                button_zh: data?.button_text_zh_1,
                button_link: data?.button_link_1
            },
            {
                id: 33,
                button_en: data?.button_text_en_2,
                button_ms: data?.button_text_ms_2,
                button_zh: data?.button_text_zh_2,
                button_link: data?.button_link_2
            },
        ],
        copyright_text_en: data?.copyright_text_en,
        copyright_text_ms: data?.copyright_text_ms,
        copyright_text_zh: data?.copyright_text_zh,
        published: true 
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response:any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === 'OK' && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else{
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response:any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === 'OK' && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else{
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <>
      <DynamicForm
        isLoading={isLoadingFaq || drilldownLoading}
        config={faqFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${magpHost}/api/footer-section-image-crud-api/${editFaq?.[0]?.id || FaqById?.payload?.id}`,
            "UPDATE",
            "PATCH",
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </>
  );
};
